import React, { useEffect, useState } from 'react'
import { Alert, Badge, Card, Col, Empty, Row, Spin, Table, Tag, Typography } from 'antd'
import { getAicDashboardSummary, getAicDashboardDatasets, getAicDashboardExceptions } from '../../request'
import './index.less'

const Unconnected = ({ label = '未接入' }) => <Tag className="aic-unconnected">{label}</Tag>
const value = (v) => v === null || v === undefined || v === '' ? <Unconnected /> : v

export default function AicDashboard () {
  const [summary, setSummary] = useState(null)
  const [datasets, setDatasets] = useState([])
  const [exceptions, setExceptions] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')
  useEffect(() => {
    Promise.all([getAicDashboardSummary({}), getAicDashboardDatasets({}), getAicDashboardExceptions({})])
      .then(([s, d, e]) => {
        setSummary(s || {})
        setDatasets(Array.isArray(d) ? d : ((d && (d.list || d.data)) || []))
        setExceptions(Array.isArray(e) ? e : ((e && (e.list || e.data)) || []))
      })
      .catch(() => setError('看板数据接口暂未接入，当前仅展示可识别字段'))
      .finally(() => setLoading(false))
  }, [])
  const columns = [
    { title: '数据源', dataIndex: 'projectName', render: value },
    { title: 'Owner', dataIndex: 'owner', render: value },
    { title: '业务主体', dataIndex: 'businessSubject', render: value },
    { title: '敏感级', dataIndex: 'sensitivityLevel', render: value },
    { title: '导入模式', dataIndex: 'defaultImportMode', render: value },
    { title: 'Schema / Published', render: (_, r) => <span>{value(r.schemaVersion)} / {value(r.publishedVersion)}</span> },
    { title: '状态', dataIndex: 'status', render: value }
  ]
  return <div className="aic-dashboard">
    <div className="aic-header"><div><Typography.Title level={3}>AIC 数据控制台</Typography.Title><Typography.Text type="secondary">数据源接入、Schema 与导入控制面</Typography.Text></div><Badge status="processing" text="只读视图" /></div>
    {error && <Alert type="warning" showIcon message={error} />}
    <Spin spinning={loading}>
      <Row gutter={[16, 16]} className="aic-summary">
        {['datasetCount', 'tableCount', 'fieldCount', 'healthyRate'].map((key, i) => <Col xs={24} sm={12} lg={6} key={key}><Card title={['数据源', '已发布表', '字段', '健康率'][i]}>{key === 'healthyRate' ? <Unconnected /> : value(summary && summary[key])}</Card></Col>)}
      </Row>
      <Card title="数据源目录" className="aic-panel"><Table rowKey={(r) => r.datasetId || r.projectId || r.id} columns={columns} dataSource={datasets} pagination={{ pageSize: 10 }} locale={{ emptyText: <Empty description="暂无已接入数据源" /> }} /></Card>
      <Card title="异常中心" className="aic-panel"><Alert type="info" message="统一运行异常、质量检测和自动修复尚未接入" description={<Unconnected label="异常数据未接入" />} showIcon />{exceptions.length > 0 && <Table rowKey="id" dataSource={exceptions} columns={[{ title: '数据源', dataIndex: 'projectName', render: value }, { title: '异常类型', dataIndex: 'type', render: value }, { title: '发生时间', dataIndex: 'occurredAt', render: value }]} />}</Card>
    </Spin>
  </div>
}
